import { render } from "./DashboardIcon.vue?vue&type=template&id=6e5bf5a8"
const script = {}
script.render = render

export default script